var _defs, _g, _style;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIphone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "210.78mm",
    height: "114.58mm",
    viewBox: "0 0 210.78 114.58",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient554"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ee6f01",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ee9801",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient20"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#800080",
    offset: 0.33518
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b200b2",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient3",
    x1: 51.574,
    x2: 74.43,
    y1: 119.34,
    y2: 119.34,
    gradientTransform: "translate(32.141 1.0583)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#800080",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b200b2",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5",
    x1: 49.71,
    x2: 60.968,
    y1: 138.96,
    y2: 138.96,
    gradientTransform: "matrix(.93155 0 0 1 36.315 3.7042)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#800080",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808",
    offset: 0.41551
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9b009b",
    offset: 0.72022
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b200b2",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient9",
    x1: 88.098,
    x2: 95.827,
    y1: 138.96,
    y2: 138.96,
    gradientTransform: "matrix(.83412 0 0 1 47.396 3.2234)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#800080",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#909",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient21",
    x1: 51.514,
    x2: 94.496,
    y1: 156.8,
    y2: 156.8,
    gradientTransform: "translate(32.141 5.8208)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient22",
    x1: 51.514,
    x2: 94.496,
    y1: 156.8,
    y2: 156.8,
    gradientTransform: "translate(32.141 24.639)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient23",
    x1: 51.514,
    x2: 94.496,
    y1: 156.8,
    y2: 156.8,
    gradientTransform: "translate(32.141 15.198)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient556",
    x1: 145.47,
    x2: 163.81,
    y1: 111.3,
    y2: 111.3,
    gradientTransform: "matrix(.93007 0 0 1 10.173 0)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient554"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient558",
    x1: 145.47,
    x2: 163.81,
    y1: 111.3,
    y2: 111.3,
    gradientTransform: "matrix(.88112 0 0 .94737 -80.793 14.256)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient554"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient563",
    x1: 145.47,
    x2: 163.81,
    y1: 111.3,
    y2: 111.3,
    gradientTransform: "matrix(.88112 0 0 .94737 -76.562 -282.89)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient554"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter592",
    x: -0.28493,
    y: -0.15038,
    width: 1.5699,
    height: 1.3008,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "fbSourceGraphic",
    stdDeviation: "3 3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "fbSourceGraphic",
    result: "blur",
    stdDeviation: "3 3"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter609",
    x: -0.28149,
    y: -0.28362,
    width: 1.6334,
    height: 1.6381,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(0,0,0)",
    floodOpacity: 0.43922,
    in: "SourceGraphic",
    result: "flood"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    result: "blur",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.2,
    dy: 1.2,
    in: "blur",
    result: "offset"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "flood",
    in2: "offset",
    operator: "in",
    result: "comp1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "comp1",
    result: "comp2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter616",
    x: -0.29713,
    y: -0.29938,
    width: 1.6685,
    height: 1.6736,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(0,0,0)",
    floodOpacity: 0.43922,
    in: "SourceGraphic",
    result: "flood"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    result: "blur",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.2,
    dy: 1.2,
    in: "blur",
    result: "offset"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "flood",
    in2: "offset",
    operator: "in",
    result: "comp1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "comp1",
    result: "comp2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter618",
    x: -0.59426,
    y: -0.6736,
    width: 2.3371,
    height: 2.3472,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(0,0,0)",
    floodOpacity: 0.43922,
    in: "SourceGraphic",
    result: "flood"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    result: "blur",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.2,
    dy: 1.2,
    in: "blur",
    result: "offset"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "flood",
    in2: "offset",
    operator: "in",
    result: "comp1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "comp1",
    result: "fbSourceGraphic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(0,0,0)",
    floodOpacity: 0.43922,
    in: "fbSourceGraphic",
    result: "flood"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "fbSourceGraphic",
    result: "blur",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.2,
    dy: -1.2,
    in: "blur",
    result: "offset"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "flood",
    in2: "offset",
    operator: "in",
    result: "comp1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "comp1",
    result: "comp2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient805",
    x1: 145.47,
    x2: 163.81,
    y1: 111.3,
    y2: 111.3,
    gradientTransform: "matrix(.93007 0 0 1 4.5213 73.288)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient554"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient827",
    x1: -10.439,
    x2: 230.77,
    y1: 215.35,
    y2: 358.75,
    gradientTransform: "translate(-7.4098 -133.86)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b660bc",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#870988",
    offset: 0.52305
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#931d99",
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.3853 -95.633)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.38613,
    y: 95.638,
    width: 210.78,
    height: 115.65,
    ry: 0,
    fill: "url(#linearGradient827)"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.9192 0 0 .96758 8.484 9.0232)",
    x: 79.731,
    y: 104.86,
    width: 50.539,
    height: 95.757,
    ry: 6.3143,
    fillOpacity: 0.5,
    filter: "url(#filter592)",
    strokeWidth: 0.27724
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 81.782,
    y: 102.3,
    width: 46.436,
    height: 97.539,
    ry: 7.9703,
    strokeWidth: 0.26821
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.68,
    y: 103.21,
    width: 44.641,
    height: 95.709,
    ry: 7.0804,
    fill: "#f9f9f9",
    strokeWidth: 0.2605
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.87 133.59c-2.2327 0-2.9889 1.3401-2.9889 3.0045v11.182c0 1.6644 0.69202 3.0045 2.9889 3.0045h3.4583v-17.191z",
    fill: "url(#linearGradient9)",
    strokeWidth: 0.31098
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.716,
    y: 111.81,
    width: 22.856,
    height: 17.191,
    rx: 3.5831,
    ry: 3.0043,
    fill: "url(#linearGradient3)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.655,
    y: 159.74,
    width: 42.982,
    height: 5.7677,
    rx: 1.4014,
    ry: 1.008,
    fill: "url(#linearGradient21)",
    strokeWidth: 0.27047
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.622 134.07v17.191h7.1496c1.8492 0 3.3375-1.3401 3.3375-3.0045v-11.182c0-1.6644-1.4883-3.0045-3.3375-3.0045z",
    fill: "url(#linearGradient5)",
    strokeWidth: 0.32864
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.655,
    y: 178.56,
    width: 42.982,
    height: 5.7677,
    rx: 1.4014,
    ry: 1.008,
    fill: "url(#linearGradient22)",
    strokeWidth: 0.27047
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.655,
    y: 169.12,
    width: 42.982,
    height: 5.7677,
    rx: 1.4014,
    ry: 1.008,
    fill: "url(#linearGradient23)",
    strokeWidth: 0.27047
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.1224 31.484)",
    filter: "url(#filter609)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.47,
    y: 102.83,
    width: 17.052,
    height: 16.924,
    ry: 3.442,
    fill: "url(#linearGradient556)",
    strokeWidth: 0.12952
  }), /*#__PURE__*/React.createElement("path", {
    d: "m159.48 109.96v6.8705h-6.8705l4.3e-4 -2.4984h1.2487l-4.2e-4 1.2492h4.3732v-4.3722l-0.62512-1e-5v-6.3e-4h-0.62426l1e-5 -1.2486zm-9.9935 4.3722v1.2497h1.8738v1.2487h-3.123v-2.4984zm7.4951-1.8738v1.8738h-1.8738v-1.8738zm-1.2492-6.8705v5.6207h-1.2492l1e-5 -4.3715h-4.9968v4.9968l4.3722-1e-5v1.2492h-5.6213v-7.4951zm-2.4984 2.4984v2.4984h-2.4984v-2.4984zm3.7476-2.499 2.4984 6.2e-4v2.4978l-1.2488-6.3e-4v-1.2486h-1.2496z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.231 -2.5642)",
    filter: "url(#filter616)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47.385,
    y: 111.68,
    width: 16.155,
    height: 16.033,
    ry: 3.2608,
    fill: "url(#linearGradient558)",
    strokeWidth: 0.1227
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59839 0 0 .59839 48.241 112.44)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.796 15.811 5.2045 5.1889m-3-10.5c0 4.1421-3.3579 7.5-7.5 7.5-4.1421 0-7.5-3.3579-7.5-7.5 0-4.1421 3.3579-7.5 7.5-7.5 4.1421 0 7.5 3.3579 7.5 7.5z",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -2.6458)"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 -1 0 -8.4667)",
    x: 51.616,
    y: -185.47,
    width: 16.155,
    height: 16.033,
    ry: 3.2608,
    fill: "url(#linearGradient563)",
    filter: "url(#filter618)",
    strokeWidth: 0.1227
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.58194 0 0 .58194 24.845 79.416)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m64.498 143.74c-1.4276 0-2.5853 1.157-2.5853 2.5853v8.7179c0 0.98051 0.54722 1.8346 1.3526 2.2725v7.9896h1.6831v-21.523c-0.14553-0.025-0.29764-0.0428-0.45042-0.0428"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.28 148.99c0-0.12446-0.0053-0.24892-0.0158-0.36942l-0.40432-4.8426h-0.68221v5.2647h-0.59858v-5.2641h-0.6776v5.2641h-0.59858v-5.2641h-0.6776v5.2641h-0.59792v-5.2647h-0.68287l-0.41552 4.7788c-0.01383 0.14224-0.02107 0.28711-0.02107 0.4333 0 1.4527 0.73489 2.7361 1.8511 3.4993v12.812h1.6989l-0.0053-12.832c1.103-0.76386 1.8273-2.0374 1.8273-3.4789"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 97.252,
    y: 104.28,
    width: 15.495,
    height: 3.7605,
    ry: 1.8803,
    strokeWidth: 0.47319
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.52917)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 139.82,
    y: 176.12,
    width: 17.052,
    height: 16.924,
    ry: 3.442,
    fill: "url(#linearGradient805)",
    filter: "url(#filter609)",
    strokeWidth: 0.12952
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59211 0 0 .59211 141.3 177.4)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12 21c3.5-3.6 7-6.8236 7-10.8 0-3.9764-3.134-7.2-7-7.2-3.866 0-7 3.2236-7 7.2 0 3.9764 3.5 7.2 7 10.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 13c1.6569 0 3-1.3431 3-3 0-1.6568-1.3431-3-3-3s-3 1.3432-3 3c0 1.6569 1.3431 3 3 3z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2.6458)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.366,
    y: 131.42,
    width: 22.856,
    height: 17.191,
    rx: 3.5831,
    ry: 3.0043,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "1.2, 1.2",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.09 139.02c-1.0425 0.462-1.8728 1.291-2.336 2.3335-0.0699 0.1573 8.4e-4 0.34079 0.15855 0.41075 0.0411 0.0187 0.0835 0.0275 0.1261 0.0275 0.1197 0 0.23347-0.069 0.28459-0.18483 0.40079-0.90138 1.1175-1.618 2.0188-2.0176 0.15734-0.0699 0.22854-0.25342 0.15861-0.41071-0.0686-0.15735-0.25343-0.2285-0.41076-0.1586zm2.6793-1.3546c0.0898-0.14732 0.14483-0.31838 0.14483-0.50314 0-0.53436-0.43324-0.96635-0.96635-0.96635-0.53435 0-0.96634 0.43324-0.96634 0.96635 0 0.18476 0.0549 0.35706 0.14483 0.50314-2.7055 0.39827-4.788 2.7342-4.788 5.5483v0.67548c0 0.17231 0.13984 0.31215 0.3121 0.31215h10.596c0.17228 0 0.31213-0.13984 0.31213-0.31215v-0.67548c-8.4e-4 -2.8141-2.085-5.1488-4.7893-5.5483zm4.165 5.9117h-9.973v-0.36336c0-2.7492 2.2373-4.9852 4.9865-4.9852 2.7492 0 4.9865 2.2361 4.9865 4.9852zm0.31094 1.251h-10.596c-0.17229 0-0.31213 0.13981-0.31213 0.31212 0 0.17229 0.13984 0.31213 0.31213 0.31213h10.596c0.17226 0 0.3121-0.13984 0.3121-0.31213 0-0.17231-0.13984-0.31212-0.3121-0.31212z",
    fill: "#800080",
    strokeWidth: 0.012485
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.0583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m112.41 110.75c-1.9851 0-3.5832 1.3401-3.5832 3.0045v11.182c0 1.6644 1.5982 3.0045 3.5832 3.0045h15.557v-17.191z",
    fill: "none",
    stroke: "#000",
    strokeDasharray: "1.2, 1.2",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.024282 0 0 .024282 112.97 112.87)",
    fill: "#800080"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m436.94 75.059c-48.38-48.402-112.63-75.059-180.96-75.059-68.283 0-132.54 26.657-180.92 75.059-48.409 48.395-75.066 112.65-75.06 180.94-6e-3 68.29 26.651 132.54 75.06 180.93 48.381 48.409 112.63 75.066 180.94 75.066l0.021-2.103 0.013 2.103c68.277 0 132.53-26.657 180.91-75.066 48.409-48.389 75.073-112.64 75.06-180.93 0.013-68.291-26.651-132.55-75.06-180.94zm-17.648 344.23c-43.695 43.681-101.7 67.749-163.29 67.756-61.596-7e-3 -119.59-24.074-163.29-67.756-43.682-43.696-67.749-101.69-67.756-163.29 7e-3 -61.604 24.074-119.6 67.756-163.3 43.708-43.681 101.7-67.742 163.29-67.749 61.597 7e-3 119.58 24.068 163.29 67.749 43.682 43.702 67.756 101.7 67.756 163.3-1e-3 61.603-24.075 119.6-67.757 163.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m256 66.838c-104.47 7e-3 -189.15 84.685-189.16 189.16 8e-3 104.48 84.692 189.16 189.16 189.16 104.48-7e-3 189.16-84.685 189.16-189.16s-84.678-189.16-189.16-189.16zm118.88 308.04c-30.459 30.439-72.428 49.231-118.88 49.238-46.456-7e-3 -88.418-18.799-118.87-49.238-30.444-30.46-49.244-72.421-49.244-118.88 7e-3 -46.457 18.799-88.418 49.244-118.88 30.454-30.439 72.416-49.231 118.87-49.238 46.457 7e-3 88.426 18.799 118.88 49.238 30.432 30.46 49.231 72.421 49.231 118.88s-18.8 88.418-49.232 118.88z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "317.08 132.11 294.88 132.42 295.91 165.36 318.1 165.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "172.79 237.95 182.97 218.02 139.19 195.66 129.01 215.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m149.95 288.85c-11.456 0-20.745 9.283-20.745 20.744 0 11.455 9.29 20.745 20.745 20.745 11.461 0 20.751-9.29 20.751-20.745 0-11.461-9.291-20.744-20.751-20.744z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m252.54 152.89c0-15.922-12.908-28.829-28.815-28.829-15.928 0-28.829 12.908-28.829 28.829 0 15.908 12.901 28.822 28.829 28.822 15.908 0 28.815-12.914 28.815-28.822z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "240.5 390.81 243.37 369.94 211.04 360.74 208.17 381.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m234.29 260.36c-13.907 0-25.184 11.277-25.184 25.177 0 13.907 11.276 25.185 25.184 25.185 13.907 0 25.178-11.278 25.178-25.185 0-13.9-11.271-25.177-25.178-25.177z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m322.52 320.47c-15.462 0-27.993 12.531-27.993 27.987 0 15.462 12.53 27.993 27.993 27.993 15.456 0 27.98-12.53 27.98-27.993 0-15.456-12.524-27.987-27.98-27.987z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m343.08 241.44c14.003 0 25.363-11.352 25.363-25.356s-11.36-25.355-25.363-25.355c-14.004 0-25.362 11.352-25.362 25.355s11.359 25.356 25.362 25.356z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "359.7 290.5 366.27 307.15 394.53 287.96 387.96 271.3"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m124.08 104.71v2.8673h-3.1902v-2.8673z",
    fill: "none",
    strokeWidth: 0.12602
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.54 105.9v-0.19952a0.17812 0.16009 0 0 0-0.1768-0.1589h-0.88662v1.1947h0.88662a0.17812 0.16009 0 0 0 0.1768-0.15889v-0.19952h0.26585v-0.47789z",
    fill: "#666",
    fillOpacity: 0.7,
    strokeWidth: 0.12602
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m122.48 105.54h-1.1511a0.17812 0.16009 0 0 0-0.17813 0.1589v0.87573a0.17812 0.16009 0 0 0 0.1768 0.16009h1.1525z",
    fillOpacity: 0.71,
    strokeWidth: 0.12602
  }), /*#__PURE__*/React.createElement("path", {
    id: "wifi-[#1029]",
    d: "m118.9 106.57 0.10353 0.10998c0.0574 0.061 0.15024 0.061 0.20746 0l0.10385-0.10998c-0.11467-0.12162-0.30032-0.12162-0.4149 0m-0.41491-0.44033 0.20746 0.22019c0.22873-0.24291 0.60108-0.24291 0.82994 0l0.20747-0.22019c-0.34375-0.36496-0.90113-0.36496-1.2449 0m1.5496-0.32356-0.0971 0.10312c-0.45832-0.48641-1.2014-0.48641-1.6599 0l-0.0971-0.10312c-0.0622-0.0661-0.0559-0.17533 0.0129-0.23372 0.53343-0.45232 1.2953-0.45232 1.8288 0 0.0687 0.0583 0.075 0.16772 0.0128 0.23372",
    fillOpacity: 0.7,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.0044099 0 0 .0044099 114.71 104.89)",
    fillOpacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m472 432h-48a24 24 0 0 1-24-24v-304a24 24 0 0 1 24-24h48a24 24 0 0 1 24 24v304a24 24 0 0 1-24 24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344 432h-48a24 24 0 0 1-24-24v-224a24 24 0 0 1 24-24h48a24 24 0 0 1 24 24v224a24 24 0 0 1-24 24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m216 432h-48a24 24 0 0 1-24-24v-160a24 24 0 0 1 24-24h48a24 24 0 0 1 24 24v160a24 24 0 0 1-24 24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88 432h-48a24 24 0 0 1-24-24v-96a24 24 0 0 1 24-24h48a24 24 0 0 1 24 24v96a24 24 0 0 1-24 24z"
  }))))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#000000;}\n")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIphone);
export default __webpack_public_path__ + "static/media/iphone.12d5d35c54863f13b0c601a3e5e8c122.svg";
export { ForwardRef as ReactComponent };